export const NG_DOC_STORE_THEME_KEY: string = 'ng-doc-theme-id';
